export default function PageTitle({ children, ...rest }) {
  return (
    <h1 className='pageTitle' {...rest}>
      {children}

      <style jsx>{`
        h1 {
          font-size: 5.4rem;
          font-weight: 700;
        }

        @media (max-width: 1024px) {
          h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </h1>
  )
}
